<script>
export default {
  name: 'ChartSeriesTypeSelect',
  props: {
    value: {
      type: String,
      default: 'overall',
    },
  },
  data() {
    return {
      chartType: 'overall',
    };
  },
};
</script>

<template>
  <ElRadioGroup
    v-model="chartType"
    class="chart-type-select"
    @change="$emit('input', $event)"
  >
    <ElRadioButton label="overall" class="chart-type-select__button">
      {{ $t('ADVERTISEMENT.REPORTING.CHART_SERIES_MODE.AGGREGATED') }}
    </ElRadioButton>

    <ElRadioButton label="separated" class="chart-type-select__button">
      {{ $t('ADVERTISEMENT.REPORTING.CHART_SERIES_MODE.SEPARATED') }}
    </ElRadioButton>
  </ElRadioGroup>
</template>

<style lang="scss">
.chart-type-select {
  .chart-type-select__button .el-radio-button__inner {
    background-color: #fff;

    height: 60px;
    line-height: 2;
    border-width: 1px;
    box-shadow: none;
    border-radius: 16px 0 0 16px !important;

    @include rtl() {
      border-radius: 0 16px 16px 0 !important;
    }
  }

  .chart-type-select__button.is-active .el-radio-button__inner {
    color: $lb-color-primary;
    border: 1px solid $lb-color-primary;
  }

  .el-radio-button:last-child .el-radio-button__inner {
    border-radius: 0 16px 16px 0 !important;
    @include rtl() {
      border-radius: 16px 0 0 16px !important;
    }
  }
}
</style>
